import { fmtDate, fmtINR } from "@/lib/format";

const FieldNote = ({ error, hint, testid }) => {
  if (error) return <span data-testid={`${testid}-error`} className="field-error mt-1 block">{error}</span>;
  if (hint) return <span className="mt-1 block font-mono text-[11px] text-slate-500">{hint}</span>;
  return null;
};

const dateHint = (type, v) => {
  if (!v) return null;
  if (type === "date") return fmtDate(v);
  if (type === "datetime-local") return `${fmtDate(v)}, ${v.slice(11, 16)} IST`;
  return null;
};

export const Field = ({ label, error, testid, hint, children, className = "" }) => (
  <label className={`block min-w-0 ${className}`}>
    <span className="field-label">{label}</span>
    {children}
    <FieldNote error={error} hint={hint} testid={testid} />
  </label>
);

export const TextField = ({ f, set, errors, k, label, type = "text", testid, ...rest }) => (
  <Field label={label} error={errors[k]} testid={testid} hint={dateHint(type, f[k])}>
    <input data-testid={testid} type={type} value={f[k]} onChange={set(k)} className={`inp ${errors[k] ? "inp-invalid" : ""}`} {...rest} />
  </Field>
);

export const MoneyField = ({ f, set, errors, k, label, testid, pct }) => (
  <Field label={label} error={errors[k]} testid={testid}
    hint={f[k] !== "" && !errors[k] && !pct ? fmtINR(f[k]) : null}>
    <div className="relative">
      <span className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-500">{pct ? "%" : "₹"}</span>
      <input data-testid={testid} type="number" inputMode="decimal" step="any" value={f[k]} onChange={set(k)}
        className={`inp pl-7 font-mono ${errors[k] ? "inp-invalid" : ""}`} />
    </div>
  </Field>
);

export const SelectField = ({ f, set, errors, k, label, testid, options, placeholder = "—" }) => (
  <Field label={label} error={errors[k]} testid={testid}>
    <select data-testid={testid} value={f[k]} onChange={set(k)} className={`inp ${errors[k] ? "inp-invalid" : ""}`}>
      <option value="">{placeholder}</option>
      {options.map((o) => (typeof o === "string"
        ? <option key={o} value={o}>{o}</option>
        : <option key={o.value} value={o.value}>{o.label}</option>))}
    </select>
  </Field>
);

export const Section = ({ title, children, testid }) => (
  <section data-testid={testid} className="space-y-3">
    <h3 className="section-title">{title}</h3>
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">{children}</div>
  </section>
);
